import { ProjectsJobsListAPI } from 'ducks/types/api-types';
import { normalizeJob } from 'ducks/utils';

export function normalizeJobs(data: ProjectsJobsListAPI[]) {
  return data.map((job) => normalizeJob(job)).sortObject('sort_datetime', 'desc');
}
